////
/// ============================================================================
/// COMPONENT / Post
/// ============================================================================
///
/// @group components
////

export default () => {

    window.$ = jQuery;

    /**
     * Video Replacement
     *
     * @global jQuery
     * @author Daniele De Nobili
     */
    (function () {
        let image = $('.js-videoimage');
        let video = $('.js-videoiframe');

        if (!image.length || !video.length) {
            return;
        }

        image.on('click', function () {
            let url = '';
            image.hide();

            if (video.data('source') === 'vimeo') {
                url = 'https://player.vimeo.com/video/' + video.data('video-id') + '?autoplay=1&byline=0&badge=0&title=0&loop=1';
            } else {
                url = 'https://www.youtube.com/embed/' + video.data('video-id') + '?showinfo=0&rel=0&autoplay=1&autohide=1&color=white';
            }

            let iframe = $('<iframe data-progress="25,50,75,90" width="1200" height="675" src="' + url + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');

            iframe.attr('data-title', video.data('title'));

            video
                .html(iframe)
                .show();
        });
    }());

    /**
     * Responsive Table
     */
    (function () {
        $('.single__body table').each(function () {
            var table = $(this),
                th = table.find('thead th'),
                headers = [];

            th.each(function () {
                headers.push($(this).text());
            });

            table.find('tbody tr').each(function () {
                var cells = $(this).find('td');

                headers.map(function (value, index) {
                    cells.eq(index).attr('data-label', value);
                });
            });
        });
    }());

};
